export default "__VITE_ASSET__CP$bWgwW__"